import { render, staticRenderFns } from "./ListDocuments.vue?vue&type=template&id=9823c964&"
import script from "./ListDocuments.vue?vue&type=script&lang=js&"
export * from "./ListDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9823c964')) {
      api.createRecord('9823c964', component.options)
    } else {
      api.reload('9823c964', component.options)
    }
    module.hot.accept("./ListDocuments.vue?vue&type=template&id=9823c964&", function () {
      api.rerender('9823c964', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/lists/components/ListDocuments.vue"
export default component.exports